import AiIcon from '../assets/images/AiIcon';
import { useChatStore } from '../stores/chatStore';

export const ChatButton = () => {
  const { isOpen, toggleChat } = useChatStore();

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        toggleChat();
      }}
      className="fixed right-4 w-14 h-14 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-40"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bottom: '55px',
        backgroundColor: isOpen ? 'var(--color-amber-300)' : 'var(--color-blue-500)',
        color: 'var(--primary-contrast-color)',
        border: '1px solid var(--color-blue-500)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = isOpen ? 'var(--color-amber-300)' : 'var(--primary-hover-color)';

      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = isOpen ? 'var(--color-amber-300)' : 'var(--color-blue-500)';
      }}
    >
      {isOpen
        ? <AiIcon color="var(--color-blue-500)" />
        : <AiIcon color="var(--surface-default)" />
    }
    </button>
  );
};